import { CommandFactory, MessageResourceManager, ViewModelTypeDecorator } from "@nts/std";
import { ChangeDetectorRef } from "@angular/core";
import { PaymentDataViewModel } from "../payment-data.view-model";
import { ModalViewModelInterface, ToastMessageServiceInterface, UIResultCommandInterface } from "@nts/std/interfaces";
import { FilledButtonType, ToastMessageType } from "@nts/std/types";

@ViewModelTypeDecorator(SupplierNotSavedViewModel)
export class SupplierNotSavedViewModel implements ModalViewModelInterface<any, any> {

  /**
   * The change detector
   */
  cd: ChangeDetectorRef;

  /**
   * The filled button type
   */
  filledButtonType = FilledButtonType;

  /**
   * The modal title
   */
  modalTitle = MessageResourceManager.Current.getMessage('ExpenseData_SupplierNotSaved_Title');

  /**
   * The modal subtitle
   */
  modalSubtitle = '';

  /**
   * The modal commands
   */
  modalCommands = [];

  /**
   * The show footer flag
   */
  showFooter = true;

  private readonly VAT_NUMBER_MAX_LENGTH = 28;

  /**
   * The confirm command
   */
  private closeCommand: UIResultCommandInterface<boolean, any>;

  constructor(
    public paymentDataViewModel: PaymentDataViewModel,
    public toastMessageService: ToastMessageServiceInterface
  ) {
    this.setupCommands();
  }

  /**
   * Setup the commands
   */
  private setupCommands() {
    this.closeCommand = CommandFactory.createResultUICommand<boolean>(async () => {
      if (!this.validate()) {
        this.closeCommand.closeModal = false;
        return false;
      }

      this.closeCommand.closeModal = true;
      return true;
    });
    this.closeCommand.displayName = MessageResourceManager.Current.getMessage("ExpenseData_SupplierNotSaved_Close_DisplayName");
    this.closeCommand.closeModal = true;
    this.closeCommand.isCancel = false;
    this.closeCommand.isDefault = true;
    this.modalCommands.push(this.closeCommand);
  }

  /**
   * Initialize the view model
   */
  async initialize(cd): Promise<void> {
    this.cd = cd;
  }

  validate(): boolean {
    const vatNumber = this.paymentDataViewModel.vatNumber;
    const businessName = this.paymentDataViewModel.businessName;
    if (vatNumber.value != null && vatNumber.value.trim().length > 0 && vatNumber.value.trim().length > (vatNumber?.maxLength || this.VAT_NUMBER_MAX_LENGTH)) {
      this.toastMessageService.showToast({
        message: MessageResourceManager.Current.getMessage('ExpenseData_SupplierNotSaved_VatNumber_Required'),
        type: ToastMessageType.error,
        title: MessageResourceManager.Current.getMessage('std_Error')
      });
      return false;
    }

    const vatNumberPopulated = vatNumber.value.trim().length > 0;
    const businessNamePopulated = businessName.value.trim().length > 0;

    if (vatNumberPopulated !== businessNamePopulated) {
      this.toastMessageService.showToast({
        message: MessageResourceManager.Current.getMessage('ExpenseData_SupplierNotSaved_FieldRequired'),
        type: ToastMessageType.error,
        title: MessageResourceManager.Current.getMessage('std_Error')
      });
      return false;
    }

    return true;
  }
}
